
import { TranslationKeys } from '@/types/translations';

const esTranslations: TranslationKeys = {
  // Navbar
  'nav.home': 'Inicio',
  'nav.properties': 'Propiedades',
  'nav.blog': 'Blog',
  'nav.about': 'Nosotros',
  'nav.contact': 'Contacto',
  'nav.login': 'Iniciar sesión',

  // Home page - SEO optimized
  'home.hero.title': 'Encuentra los mejores hospedajes',
  'home.hero.highlight': 'en Manzanillo, Colima',
  'home.hero.subtitle': 'Propiedades vacacionales que te harán sentir en casa.',
  'home.hero.search_form_title': 'Reserva tu estadía',
  'home.hero.checkin': 'Entrada',
  'home.hero.checkout': 'Salida',
  'home.hero.guests': 'Huéspedes',
  'home.hero.bullet_one': 'Solo super anfitriones',
  'home.hero.bullet_two': 'Reserva rápida',
  'home.hero.bullet_three': 'Cancelación flexible',
  'home.hero.average_rating': 'Valoración promedio',
  'home.hero.reviews_count': '4.97/5 · 65 evaluaciones',

  // Properties page
  'properties.title': 'Alojamientos en Manzanillo',
  'properties.subtitle': 'Si vienes de vacaciones o de trabajo, en familia, con amigos o pareja. Tenemos un alojamiento ideal para ti.',

  // Stats
  'stats.bookings': 'Reservaciones realizadas',
  'stats.happy_guests': 'Huéspedes felices',
  'stats.average_score': 'Puntuación media',
  'stats.support': 'Soporte',

  // Featured properties
  'featured.title': 'Alojamientos destacados en Manzanillo',
  'featured.subtitle': '¿Hoteles? Mejor alojate en alguna de nuestras propiedaes y disfruta como en casa.',

  // How it works
  'how_it_works.title': 'Cómo reservar tu alojamiento',
  'how_it_works.subtitle': 'Reserva tu propiedad ideal en solo 3 pasos',
  'how_it_works.search.title': 'Busca',
  'how_it_works.search.description': 'Explora las propiedades que tenemos disponibles en Manzanillo.',
  'how_it_works.book.title': 'Reserva',
  'how_it_works.book.description': 'Realiza tu solicitud de reservación.',
  'how_it_works.enjoy.title': 'Paga',
  'how_it_works.enjoy.description': 'Nos pondremos en contacto contigo para el pago.',

  // Reviews
  'reviews.title': 'Opiniones de los huéspedes',
  'reviews.subtitle': '¡Te haremos sentir en casa! Ellos lo confirman.',
  'reviews.review_one_comment': 'El apartamento era absolutamente encantador y superaba mis expectativas. Era limpio, cómodo y bien equipado con todo lo que necesitaba. La decoración era moderna y elegante, y la ubicación era perfecta para explorar la ciudad.',
  'reviews.review_one_location': 'Jalisco, México',
  'reviews.review_two_comment': 'El departamento es muy muy bonito, esta impecable por donde lo veas. La zona muy céntrica, bonita y con lugares, para comer, divertirse, pasear. Quedamos encantados con el departamento',
  'reviews.review_two_location': 'Jalisco, México',
  'reviews.review_three_comment': 'El apartamento está en un complejo muy bonito. Las instalaciones están impecables y muy bien cuidadas. La piscina increíble. Los anfitriones se pusieron en contacto para asegurarse de que todo estuviera bien y fueron muy amables.',
  'reviews.review_three_location': 'Campbell River, Canadá',

  // FAQ
  'faq.title': 'Preguntas frecuentes',
  'faq.subtitle': 'Encuentra respuestas a las preguntas más comunes sobre nuestras propiedades y servicios.',
  'faq.question_one': '¿Qué amenidades tiene el condominio?',
  'faq.answer_one': 'Cuenta con alberca poco profunda al aire libre y a temperatura ambiente. También encontrarás áreas verdes, áreas infantiles, una palapa y camastros.',
  'faq.question_two': '¿A cuánto tiempo queda la playa más cercana?',
  'faq.answer_two': 'La playa más cercana se encuentra a solo 5 minutos caminando desde el condominio. Es una playa tranquila ideal para familias con aguas cristalinas.',
  'faq.question_three': '¿Las propiedades cuentan con estacionamiento?',
  'faq.answer_three': 'Sí, todas nuestras propiedades incluyen estacionamiento privado y seguro para nuestros huéspedes sin costo adicional.',
  'faq.question_four': '¿A qué hora es la hora de entrada y de salida?',
  'faq.answer_four': 'La hora de entrada es a partir de las 3:00 PM y la salida es hasta las 11:00 AM. Podemos ser flexibles con los horarios según disponibilidad.',
  'faq.question_five': '¿Las propiedades son ideales para familias?',
  'faq.answer_five': 'Absolutamente. Nuestras propiedades son ideales para familias con espacios amplios, áreas seguras para niños y todas las comodidades necesarias.',
  'faq.question_six': '¿En qué planta se encuentran ubicadas las propiedades?',
  'faq.answer_six': 'Contamos con propiedades en diferentes plantas del edificio, desde planta baja hasta el tercer piso, todas con excelentes vistas y fácil acceso.',
  'faq.question_seven': '¿Se permiten mascotas?',
  'faq.answer_seven': 'No en todas las propiedades están permitidas las mascotas, en la gran mayoría es por reglas del condominio.',

  // Footer
  'footer.description': 'Alojamientos vacacionales que te harán sentir en casa',
  'footer.links': 'Enlaces',
  'footer.contact': 'Contacto',
  'footer.estancia_corta': 'Estancia Corta',
  'footer.management': 'Gestión de propiedades',
  'footer.publish': 'Publica tu propiedad',
  'footer.rights': 'Todos los derechos reservados.',
  'footer.privacy_policy': 'Políticas de privacidad',

  // Search form
  'search.guests': 'Huéspedes',
  'search.checkin': 'Llegada',
  'search.checkout': 'Salida',
  'search.button': 'Buscar',

  // About page
  'about.hero.title': '¿Quiénes somos?',
  'about.hero.description.first': 'Somos una empresa quebusca ofrecer a nuestros huéspedes solo los mejores alojamientos en Manzanillo. Creemos que un buen alojamiento es el inicio de un gran viaje.',
  'about.hero.description.second': 'Solo publicamos propiedades de Super anfitriones, de esta manera nos aseguramos de brindar la mejor experiencia para nuestros huéspedes.',
  'about.stats.bookings': 'Reservaciones registradas',
  'about.stats.guests': 'Huéspedes felices',
  'about.stats.rating': 'Puntuación media',
  'about.mission.title': 'Nuestra Misión',
  'about.mission.description': 'Crear experiencias de viaje que superen las expectativas de los huéspedes ofreciéndoles los mejores alojamientos de Manzanillo.',
  'about.values.title': 'Nuestros Valores',
  'about.values.excellence.title': 'Excelencia',
  'about.values.excellence.description': 'Nos comprometemos a ofrecer la más alta calidad en cada detalle de nuestros servicios y propiedades.',
  'about.values.hospitality.title': 'Hospitalidad',
  'about.values.hospitality.description': 'Tratamos a cada huésped como familia, proporcionando un servicio personalizado y cálido que hace la diferencia.',
  'about.values.sustainability.title': 'Sostenibilidad',
  'about.values.sustainability.description': 'Respetamos y protegemos el entorno natural que nos rodea, implementando prácticas sostenibles en todas nuestras operaciones.',
  'about.property_owners.title': '¿Tienes una propiedad?',
  'about.property_owners.subtitle': 'Maximiza el potencial de tu propiedad con nuestros servicios profesionales',
  'about.property_owners.management.title': 'Gestión Integral',
  'about.property_owners.management.description': 'Nos encargamos de todo: desde la limpieza y mantenimiento hasta la atención al huésped.',
  'about.property_owners.marketing.title': 'Marketing Profesional',
  'about.property_owners.marketing.description': 'Fotografía profesional, descripciones optimizadas y estrategias de precios competitivos.',
  'about.property_owners.support.title': 'Soporte 24/7',
  'about.property_owners.support.description': 'Atención continua a tus huéspedes y resolución inmediata de cualquier situación.',
  'about.property_owners.cta': 'Contáctanos para más información',
};

export default esTranslations;
